import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Action, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import moment from 'moment';
import { isObject } from 'lodash';
import * as bootstrap from 'bootstrap';
import store from '@/store';
import { hideModal } from '@/core/helpers/dom';
import { MutationsGeneral } from '@/store/enums/pscm/migo/generalEnum';
let transactionModule = class transactionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isOnImport = false;
        this.isGrSearched = false;
        this.isGrPrinted = false;
        this.importCondition = 'gr';
        this.tabConditionGr = 'header';
        this.successClose = false;
        this.tempId = null;
        this.preventDiscard = false;
        this.importFileGrOther = {
            files: null,
            store: [],
            isError: false,
            isImported: false,
            isAllowImport: true,
            isOnAsync: false
        };
        this.errorListGrOther = [
            {
                materialDesc: false,
                qty: false,
                slocCode: false,
                reasonForMovement: false,
                stockTypeCode: false,
                vendorName: false,
                costCenter: false,
                order: false
            }
        ];
        this.errorListGrCreate = [
            {
                qty: false,
                slocCode: false,
                reasonForMovement: false
            }
        ];
        this.grLookup = {
            typeorder: [
                {
                    lookupVal: 'PurchaseOrder',
                    lookupText: 'Purchase Order',
                    lookupData: null,
                    lookupValText: 'PurchaseOrder | Purchase Order'
                },
                {
                    lookupVal: 'Other',
                    lookupText: 'Other',
                    lookupData: null,
                    lookupValText: 'Other | Other'
                }
            ],
            stockType: [],
            delCompleteInd: [],
            sloc: [],
            mvtype: [],
            specialstock: [],
            valType: []
        };
        this.headerId = 0;
        this.grOtherLookup = {
            material: [],
            valType: [],
            mvtype: [],
            specialstock: [],
            plant: [],
            stocktype: [],
            sloc: [],
            slocHead: [],
            reasonMv: [],
            costcenter: [],
            vendor: []
        };
        this.viewHeader = {};
        this.grHeaderForm = {
            typeReceipt: 'Goods Receipt',
            typeOrder: null,
            noPurchaseOrder: null,
            poItem: null,
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            grUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadGrPo: [],
            movementType: null,
            specialStock: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false,
            orderNumber: null,
            reservationNumber: null,
            equipment: null,
            orderCreator: ''
        };
        this.headerError = {
            documentDate: false,
            deliveryNote: false,
            postingDate: false,
            docHeaderText: false
        };
        this.listGrItem = {
            data: [],
            totalPages: 0,
            totalRecords: 0
        };
        this.listGrOther = {
            data: [],
            totalPages: 0,
            totalRecords: 0
        };
        this.typeUrl = '';
        this.listGrOtherChange = {
            data: []
        };
        this.tempEditItem = [];
        this.grItemSelected = {
            current: {},
            list: [],
            selectedItem: [],
            isAllSelected: false
        };
        this.tempGrOther = [];
        this.payloadGr = {};
        this.nextPrevItems = {
            data: []
        };
        this.errorLists = {
            postClicked: false,
            checkClicked: false,
            requiredAll: false,
            snNotSame: false,
            listItem: [],
            listHeader: []
        };
        this.showEdit = false;
        this.hideEdit = true;
        this.printGrUrl = '';
    }
    get getPayloadGr() {
        return this.payloadGr;
    }
    ['setPayloadGr'](data) {
        this.payloadGr = data;
    }
    get getIsOnImportGr() {
        return this.isOnImport;
    }
    get getNextPrevItemsGrMigo() {
        return this.nextPrevItems;
    }
    get getErrorListGrOther() {
        return this.errorListGrOther;
    }
    get getErrorListGrCreate() {
        return this.errorListGrCreate;
    }
    get getImportFileGrOther() {
        return this.importFileGrOther;
    }
    get getPreventDiscard() {
        return this.preventDiscard;
    }
    get getTempGrOther() {
        return this.tempGrOther;
    }
    get getTabConditionsGr() {
        return this.tabConditionGr;
    }
    get getImportConditionMigo() {
        return this.importCondition;
    }
    get getIsGrSearched() {
        return this.isGrSearched;
    }
    get getIsGrPrinted() {
        return this.isGrPrinted;
    }
    get getSuccessClose() {
        return this.successClose;
    }
    get getGrLookup() {
        return this.grLookup;
    }
    get getGrOtherLookup() {
        return this.grOtherLookup;
    }
    get getGrHeaderForm() {
        return this.grHeaderForm;
    }
    get getHeaderError() {
        return this.headerError;
    }
    get getGrItemSelected() {
        return this.grItemSelected;
    }
    get getErrorLists() {
        return this.errorLists;
    }
    get getTempItem() {
        return this.tempEditItem;
    }
    get getListGrOther() {
        return this.listGrOther;
    }
    get getTempId() {
        return this.tempId;
    }
    get getHeaderId() {
        return this.headerId;
    }
    get getViewHeader() {
        return this.viewHeader;
    }
    ['setPlantListGr'](data) {
        this.listGrOther.data[data.index].whereTab.plantCode = data.plantCodeValue;
        this.listGrOther.data[data.index].whereTab.plantName = data.plantNameValue;
    }
    ['setIsOnImportGr'](data) {
        this.isOnImport = data;
    }
    ['setNextPrevGrMigo'](data) {
        this.nextPrevItems.data = data;
    }
    ['setImportConditionMigo'](data) {
        this.importCondition = data;
    }
    get getListGrOtherChange() {
        return this.listGrItem;
    }
    ['setListGrOtherChange'](data) {
        this.listGrItem = data;
    }
    ['setGrHeader'](data) {
        this.grHeaderForm.noPurchaseOrder = data.header.poNumber;
        this.grHeaderForm.poItem = data.header.poItem;
        this.grHeaderForm.supplier = data.header.vendor.vendorName;
        this.grHeaderForm.vendorNumber = data.header.vendor.vendorCode;
        this.grHeaderForm.vendorName = data.header.vendor.vendorName;
        this.grHeaderForm.orderNumber = data.header.orderNumber;
        this.grHeaderForm.orderCreator = data.header.orderCreator;
        this.grHeaderForm.reservationNumber = data.header.reservationNumber;
        this.grHeaderForm.equipment = data.header.equipment;
    }
    ['setImportFileGrOther']({ files, data, isError }) {
        if (isError)
            this.importFileGrOther.isError = isError;
        else {
            this.importFileGrOther.store.push(data);
            this.importFileGrOther.files = files;
            this.importFileGrOther.isError = isError;
        }
    }
    ['deleteImportFileGrOtherr'](fileName) {
        const index = this.importFileGrOther.store
            .map((x) => {
            return x.originalFileName;
        })
            .indexOf(fileName);
        this.importFileGrOther.store.splice(index, 1);
        this.importFileGrOther.files = null;
        this.importFileGrOther.isError = false;
    }
    ['setDetailGrHeader'](data) {
        const header = data.header;
        this.grHeaderForm.noPurchaseOrder = header.poNumber;
        this.grHeaderForm.poItem = header.poItem;
        this.grHeaderForm.supplier = header.vendor.vendorName;
        this.grHeaderForm.vendorNumber = header.vendor.vendorCode;
        this.grHeaderForm.vendorName = header.vendor.vendorName;
        this.grHeaderForm.typeOrder = header.typeOrder;
        this.grHeaderForm.documentDate = moment(header.documentDate).format('DD MMM YYYY');
        this.grHeaderForm.deliveryNote =
            data.type === 'change' && header.typeOrder !== 'PurchaseOrder'
                ? header.materialSlip
                : header.deliveryNote;
        this.grHeaderForm.postingDate = moment(header.postingDate).format('DD MMM YYYY');
        this.grHeaderForm.billOfLading = header.billofLading;
        this.grHeaderForm.headerText = header.docHeaderText;
        this.grHeaderForm.movementType = header.movementType;
        this.grHeaderForm.specialStock = header.specialStock;
        this.grHeaderForm.documentStatus = header.documentStatus;
        this.grHeaderForm.documentStatusCode = header.documentStatusCode;
        this.grHeaderForm.documentType = header.documentType;
        this.grHeaderForm.bSpaceMatDoc = header.bSpaceMatDoc;
        this.grHeaderForm.materialDocument = header.materialDocument;
        this.grHeaderForm.materialSlip = header.materialSlip;
        this.grHeaderForm.uploadGrPo = data.attachments;
        (this.grHeaderForm.hasMatDoc = header.hasMatDoc),
            (this.grHeaderForm.movementType = header.movementType);
        this.grHeaderForm.specialStock = header.specialStock;
        this.grHeaderForm.isCancelDoc = header.isCancelDoc;
        this.grHeaderForm.orderNumber = header.orderNumber;
        this.grHeaderForm.reservationNumber = header.reservationNumber;
        this.grHeaderForm.equipment = header.equipment;
        this.grHeaderForm.orderCreator = header.orderCreator;
    }
    ['deleteErrorListGrOther']() {
        this.errorListGrOther = [];
    }
    ['afterCountDown'](data) {
        data.forEach((g) => {
            if (g.field.tabCode.toLowerCase() != 'header') {
                const split = g.field.name.split('-');
                const index = this.listGrOther.data.findIndex((e) => {
                    return e.line == split[1];
                });
                this.errorListGrOther[index][split[2]] = true;
                this.listGrOther.data[index].onEdit = true;
                this.listGrOther.data[index].isActive = true;
                this.listGrOther.data[index].isDisabledDelete = true;
            }
        });
    }
    ['setTempGrOther']({ value, tabParent, tabChild, line }) {
        const index = this.tempGrOther.findIndex((e) => {
            return e.line == line;
        });
        this.tempGrOther[index][tabParent][tabChild] = value;
    }
    ['resetTempGrOther']() {
        this.tempGrOther = [];
    }
    ['pushTempGrOther'](data) {
        this.tempGrOther.push(data);
    }
    ['updateErrorListGrOther']({ index, obj, condition }) {
        this.errorListGrOther[index][obj] = condition;
    }
    ['setErrorListGrOther'](data) {
        this.errorListGrOther.push(data);
    }
    ['setPreventDiscardMigo'](data) {
        this.preventDiscard = data;
    }
    ['setTypeOrder'](data) {
        this.grHeaderForm.typeOrder = data;
    }
    ['setTempItem'](data) {
        this.tempEditItem = data;
    }
    ['setTabConditionsGr'](data) {
        this.tabConditionGr = data;
    }
    ['setGrLookup']({ obj, data }) {
        this.grLookup[obj] = data;
    }
    ['setGrOtherLookup']({ obj, data }) {
        this.grOtherLookup[obj] = data;
    }
    ['setGrPoUpload'](data) {
        this.grHeaderForm.uploadGrPo.push(data);
    }
    ['setIsGrSearched'](data) {
        this.isGrSearched = data;
    }
    ['setIsGrPrinted'](data) {
        this.isGrPrinted = data;
    }
    ['setSuccessClose'](data) {
        this.successClose = data;
    }
    ['setCurrentItemSelected'](data) {
        this.grItemSelected.current = data;
    }
    ['setListItemSelected'](data) {
        const check = this.grItemSelected.list.findIndex((s) => {
            return s.detailId == data.detailId;
        });
        if (check != -1)
            return (this.grItemSelected.list[check] = data);
        this.grItemSelected.list.push(data);
    }
    ['setEditItemSelected']({ index, data }) {
        this.grItemSelected.list[index] = data;
    }
    ['setEditItemSelectedClear']() {
        this.grItemSelected.list = [];
    }
    ['setSelectedListItem'](data) {
        this.grItemSelected.selectedItem = data;
    }
    ['setSelectedListItemByIndex']({ index, data }) {
        this.grItemSelected.selectedItem[index] = data;
    }
    ['setSelectedItem'](data) {
        this.grItemSelected.selectedItem.push(data);
    }
    ['setDeleteSelectedItem'](data) {
        this.grItemSelected.selectedItem.splice(data, 1);
    }
    ['setClearSelectedItem']() {
        this.grItemSelected.selectedItem = [];
    }
    ['setSelectedAllItem'](data) {
        this.grItemSelected.isAllSelected = data;
    }
    get getListGrItem() {
        return this.listGrItem;
    }
    ['setListGrItem'](data) {
        this.listGrItem = data;
    }
    ['setListGrItemOther'](data) {
        this.listGrOther = data;
    }
    ['setErrorRequiredAll'](data) {
        this.errorLists.requiredAll = data;
    }
    ['setErrorSnNotSame'](data) {
        this.errorLists.snNotSame = data;
    }
    ['setErrorListItem'](data) {
        this.errorLists.listItem = data;
    }
    ['setErrorListItemPush'](data) {
        this.errorLists.listItem.push(data);
    }
    ['setErrorListItemUnshift'](data) {
        this.errorLists.listItem.unshift(data);
    }
    ['setErrorListHeader'](data) {
        this.errorLists.listHeader = data;
    }
    ['setPostClicked'](data) {
        this.errorLists.postClicked = data;
    }
    ['setTempIdVal'](data) {
        this.tempId = data;
    }
    ['setHeaderId'](data) {
        this.headerId = data;
    }
    ['setIsSnNotBlank'](data) {
        this.grItemSelected.current.isSnNotBlank = data;
    }
    ['setStorageBin'](data) {
        this.grItemSelected.current.whereTab.storageBin = data;
    }
    ['setMaterialDetail'](data) {
        this.grItemSelected.current.materialTab.material = data.val;
        this.grItemSelected.current.materialTab.materialGroup = data.group;
    }
    ['setBaseUomSku'](data) {
        this.grItemSelected.current.quantityTab.baseUom = data;
        this.grItemSelected.current.quantityTab.baseSku = data;
    }
    ['setResetSn']() {
        this.grItemSelected.current.serialNumberTab.isSNIndicator = false;
        this.grItemSelected.current.serialNumberTab.listSerialNumbers = '';
    }
    ['addGrOther']() {
        let isOrderDisabled = false;
        let isCostCenterDisabled = false;
        if (this.grHeaderForm.movementType == '202')
            isOrderDisabled = true;
        else
            isCostCenterDisabled = true;
        const obj = {
            materialTab: {
                material: null,
                materialDesc: null,
                supplierMatNo: null,
                materialGroup: null,
                valType: null,
                valCat: null,
                mpnMaterial: null,
                equipment: null
            },
            quantityTab: {
                baseUom: null,
                qtySKU: null,
                baseSku: null,
                quantityOrdered: null,
                uoMOrdered: null,
                qty: null,
                goodsReceiptQuantity: null
            },
            whereTab: {
                movementType: this.grHeaderForm.movementType,
                slocCode: null,
                specialStock: this.grHeaderForm.specialStock,
                type: null,
                plantCode: null,
                plantName: null,
                textItem: null,
                stockTypeCode: 'UnrestrictedUse',
                storageBin: null,
                unloadingPoint: null,
                goodsRecipient: null,
                vendorCode: null,
                vendorName: null,
                reasonForMovement: null
            },
            poDataTab: {
                purchaseOrder: null,
                purchaseOrderItem: null,
                requsitioner: null,
                delCompleteIndCode: null
            },
            partnerTab: {
                manufacturer: null,
                manufacturerNumber: null,
                plantNumber: null,
                supplyingPlant: null,
                supplyingPlantNumber: null,
                vendorCode: null,
                vendorName: null
            },
            accountAssignmentTab: {
                profitCenter: null,
                costCenter: null,
                glAccount: null,
                asset: null,
                assetSubNumber: null,
                functionalArea: null,
                wbsElement: null,
                order: null,
                orderDisabled: isOrderDisabled,
                costCenterDisabled: isCostCenterDisabled
            },
            serialNumberTab: {
                isSNIndicator: false,
                listSerialNumbers: null
            },
            enableFields: [
                'materialTab.materialDesc',
                'materialTab.valType',
                'quantityTab.qty',
                'whereTab.movementType',
                'whereTab.specialStock',
                'whereTab.slocCode',
                'whereTab.reasonForMovement',
                'whereTab.reasonMovement',
                'whereTab.goodsRecipient',
                'whereTab.unloadingPoint',
                'whereTab.stockTypeCode',
                'whereTab.textItem',
                'whereTab.plantName',
                'partnerTab.vendorName',
                'accountAssignmentTab.costCenter',
                'accountAssignmentTab.order'
            ],
            popoitemgrid: null,
            subConts: null,
            hideFields: [
                'materialTab.supplierMatNo',
                'materialTab.mpnMaterial',
                'materialTab.equipment',
                'quantityTab.quantityOrdered',
                'quantityTab.uoMOrdered',
                'quantityTab.goodsReceiptQuantity',
                'poDataTab.requsitioner',
                'poDataTab.purchaseOrder',
                'poDataTab.purchaseOrderItem',
                'poDataTab.delCompleteIndCode',
                'whereTab.vendorName',
                'whereTab.vendorCode',
                'partnerTab.supplyingPlant',
                'partnerTab.supplyingPlantNumber',
                'partnerTab.plantNumber',
                'partnerTab.manufacturer',
                'partnerTab.manufacturerNumber',
                'accountAssignmentTab.asset',
                'accountAssignmentTab.assetSubNumber',
                'accountAssignmentTab.functionalArea',
                'accountAssignmentTab.glAccount',
                'accountAssignmentTab.wbsElement',
                'accountAssignmentTab.businessArea',
                'accountAssignmentTab.profitCenter'
            ],
            line: this.listGrOther.data.length + 1,
            detailId: this.listGrOther.data.length + 1,
            materialDocumentItem: null,
            categoryItem: null,
            isSnNotBlank: false,
            totalRecords: null,
            createdBy: null,
            createdDate: null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: true,
            isActive: true,
            isSaved: false,
            isSaveClicked: false,
            grType: 1,
            hasChildren: false,
            isDisabledDelete: false
        };
        this.listGrOther.data.push(obj);
        this.grItemSelected.current = obj;
        const check = this.grItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1)
            return;
        this.grItemSelected.list.push(obj);
    }
    ['addGrOtherFromImport'](data) {
        const inputOtherType = data.type
            ? data.type === 'change' || data.type === 'cancel'
                ? true
                : false
            : false;
        const isOtherAndIsChange = (data.type === 'change' || data.type === 'cancel') &&
            this.grHeaderForm.typeOrder === 'Other';
        let isOrderDisabled = false;
        let isCostCenterDisabled = false;
        if (data.whereTab.movementType == '202')
            isOrderDisabled = true;
        else
            isCostCenterDisabled = true;
        const obj = {
            materialTab: inputOtherType && !isOtherAndIsChange
                ? data.materialTab
                : {
                    material: data.materialTab.materialDesc,
                    materialDesc: {
                        lookupVal: data.materialTab.material,
                        lookupText: data.materialTab.materialDesc,
                        lookupValText: data.materialTab.material +
                            ' | ' +
                            data.materialTab.materialDesc,
                        lookupData: null
                    },
                    supplierMatNo: data.materialTab.supplierMatNo,
                    materialGroup: data.materialTab.materialGroup,
                    valType: data.materialTab.valType,
                    valCat: data.materialTab.valCat,
                    mpnMaterial: data.materialTab.mpnMaterial,
                    equipment: data.materialTab.equipment
                },
            quantityTab: {
                baseUom: data.quantityTab.baseUom,
                qtySKU: data.quantityTab.qtySKU,
                baseSku: data.quantityTab.baseSku,
                quantityOrdered: data.quantityTab.quantityOrdered,
                uoMOrdered: data.quantityTab.uoMOrdered,
                qty: data.quantityTab.qty,
                goodsReceiptQuantity: data.quantityTab.goodsReceiptQuantity
            },
            whereTab: {
                movementType: data.whereTab.movementType,
                slocCode: data.whereTab.slocCode,
                specialStock: data.whereTab.specialStock,
                type: data.whereTab.type,
                plantCode: data.whereTab.plantCode,
                plantName: {
                    lookupVal: data.whereTab.plantCode,
                    lookupText: data.whereTab.plantName,
                    lookupValText: data.whereTab.plantCode + ' | ' + data.whereTab.plantName,
                    lookupData: null
                },
                textItem: data.whereTab.textItem,
                stockTypeCode: data.whereTab.stockTypeCode,
                storageBin: data.whereTab.storageBin,
                unloadingPoint: data.whereTab.unloadingPoint,
                goodsRecipient: data.whereTab.goodsRecipient,
                vendorCode: inputOtherType ? data.whereTab.vendorCode : null,
                vendorName: inputOtherType ? data.whereTab.vendorName : null,
                reasonForMovement: data.whereTab.reasonMovementCode,
                reasonMovementDisplay: data.whereTab.reasonMovementDisplay,
                slocName: data.whereTab.slocName,
                stockTypeName: data.whereTab.stockTypeName
            },
            poDataTab: inputOtherType
                ? data.poDataTab
                : {
                    purchaseOrder: null,
                    purchaseOrderItem: null,
                    requsitioner: null,
                    delCompleteIndCode: null
                },
            partnerTab: inputOtherType
                ? data.partnerTab
                : {
                    manufacturer: null,
                    manufacturerNumber: null,
                    plantNumber: null,
                    supplyingPlant: null,
                    supplyingPlantNumber: null,
                    vendorCode: data.partnerTab.vendorCode,
                    vendorName: data.partnerTab.vendorCode !== null &&
                        data.partnerTab.vendorCode !== ''
                        ? {
                            lookupVal: data.partnerTab.vendorCode,
                            lookupText: data.partnerTab.vendorName,
                            lookupValText: data.partnerTab.vendorCode +
                                ' | ' +
                                data.partnerTab.vendorName,
                            lookupData: null
                        }
                        : null
                },
            accountAssignmentTab: inputOtherType
                ? data.accountAssignmentTab
                : {
                    profitCenter: data.accountAssignmentTab.profitCenter,
                    costCenter: data.accountAssignmentTab.costCenter,
                    glAccount: data.accountAssignmentTab.glAccount,
                    asset: data.accountAssignmentTab.asset,
                    assetSubNumber: data.accountAssignmentTab.assetSubNumber,
                    functionalArea: data.accountAssignmentTab.functionalArea,
                    wbsElement: data.accountAssignmentTab.wbsElement,
                    order: data.accountAssignmentTab.order,
                    orderDisabled: isOrderDisabled,
                    costCenterDisabled: isCostCenterDisabled
                },
            serialNumberTab: inputOtherType
                ? data.serialNumberTab
                : {
                    isSNIndicator: data.serialNumberTab.isSNIndicator,
                    listSerialNumbers: data.serialNumberTab.listSerialNumbers
                },
            enableFields: inputOtherType
                ? data.enableFields
                : [
                    'materialTab.materialDesc',
                    'materialTab.valType',
                    'quantityTab.qty',
                    'whereTab.movementType',
                    'whereTab.specialStock',
                    'whereTab.slocCode',
                    'whereTab.reasonForMovement',
                    'whereTab.reasonMovement',
                    'whereTab.goodsRecipient',
                    'whereTab.unloadingPoint',
                    'whereTab.stockTypeCode',
                    'whereTab.textItem',
                    'whereTab.plantName',
                    'partnerTab.vendorName',
                    'accountAssignmentTab.costCenter',
                    'accountAssignmentTab.order'
                ],
            popoitemgrid: inputOtherType ? data.popoitemgrid : null,
            subConts: inputOtherType ? data.subConts : null,
            hideFields: inputOtherType
                ? data.hideFields
                : [
                    'materialTab.supplierMatNo',
                    'materialTab.mpnMaterial',
                    'materialTab.equipment',
                    'quantityTab.quantityOrdered',
                    'quantityTab.uoMOrdered',
                    'quantityTab.goodsReceiptQuantity',
                    'poDataTab.requsitioner',
                    'poDataTab.purchaseOrder',
                    'poDataTab.purchaseOrderItem',
                    'poDataTab.delCompleteIndCode',
                    'whereTab.vendorName',
                    'whereTab.vendorCode',
                    'partnerTab.supplyingPlant',
                    'partnerTab.supplyingPlantNumber',
                    'partnerTab.plantNumber',
                    'partnerTab.manufacturer',
                    'partnerTab.manufacturerNumber',
                    'accountAssignmentTab.asset',
                    'accountAssignmentTab.assetSubNumber',
                    'accountAssignmentTab.functionalArea',
                    'accountAssignmentTab.glAccount',
                    'accountAssignmentTab.wbsElement',
                    'accountAssignmentTab.businessArea',
                    'accountAssignmentTab.profitCenter'
                ],
            line: data.line,
            detailId: inputOtherType ? data.detailId : data.line,
            materialDocumentItem: data.materialDocumentItem,
            categoryItem: inputOtherType ? data.categoryItem : null,
            isSnNotBlank: data.isSnNotBlank,
            totalRecords: inputOtherType ? data.totalRecords : null,
            createdBy: inputOtherType ? data.createdBy : null,
            createdDate: inputOtherType ? data.createdDate : null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: false,
            isActive: inputOtherType ? false : true,
            isSaved: true,
            isSaveClicked: false,
            isDisabledDelete: false,
            isCanceled: data.isCanceled,
            isCancelDoc: data.isCancelDoc,
            disableCheckbox: data.type === 'cancel' ? data.isCanceled : false,
            hasChildren: data.hasChildren
        };
        const errorListObj = {
            materialDesc: false,
            qty: false,
            slocCode: false,
            reasonForMovement: false,
            stockTypeCode: false,
            vendorName: false,
            costCenter: false,
            order: false
        };
        this.errorListGrOther.push(errorListObj);
        this.listGrOther.data.push(obj);
        this.grItemSelected.current = obj;
        const check = this.grItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1)
            return;
        this.grItemSelected.list.push(obj);
        if (obj.isCanceled === true && data.type === 'cancel')
            return;
        else
            this.grItemSelected.selectedItem.push(obj);
    }
    ['setViewHeader'](data) {
        this.viewHeader = data;
    }
    ['setImportPopup']() {
        const myModal = new bootstrap.Modal(document.getElementById('modal_import_gr_item'));
        myModal.show();
    }
    ['callSearchGrPo']({ conditions, payload, setLine }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/po/` +
                conditions +
                '?ver=v1';
            const params = Object.assign(Object.assign({ poNumber: this.grHeaderForm.noPurchaseOrder != null
                    ? `${this.grHeaderForm.noPurchaseOrder}`
                    : null, poItem: this.grHeaderForm.poItem != null ? `${this.grHeaderForm.poItem}` : null }, payload), { tempId: this.tempId });
            if (conditions === 'item')
                params.tempId === this.tempId;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result;
                    this.context.commit('reseterrorListGrCreate');
                    if (data.isError) {
                        this.context.commit('setErrorHandlerMigo', data);
                        resolve();
                    }
                    else {
                        const content = data.content;
                        if (conditions == 'header') {
                            this.context.commit('setGrHeader', content);
                            this.context.commit('setIsGrSearched', true);
                            const tempIdVal = content.header.tempId;
                            this.context.commit('setTempIdVal', tempIdVal);
                        }
                        else if (conditions == 'item') {
                            const list = content;
                            const csList = [];
                            content.data.forEach((g) => {
                                this.errorListGrCreate.push({
                                    qty: false,
                                    slocCode: false,
                                    reasonForMovement: false
                                });
                                g.quantityTab.qty = g.quantityTab.qty.toString();
                                csList.push(Object.assign({ checked: false, onEdit: false, isActive: false }, g));
                            });
                            list.data = csList;
                            this.grItemSelected.list.forEach((g) => {
                                const check = list.data.findIndex((s) => {
                                    return s.detailId === g.detailId;
                                });
                                if (check != -1) {
                                    list.data[check] = g;
                                    if (check === setLine - 1)
                                        this.context.commit('setCurrentItemSelected', g);
                                }
                            });
                            this.grItemSelected.selectedItem.forEach((itemSelect) => {
                                const checkIndex = list.data.findIndex((item) => {
                                    return item.detailId === itemSelect.detailId;
                                });
                                if (checkIndex !== -1) {
                                    list.data[checkIndex].isActive = itemSelect.isActive;
                                }
                            });
                            const firstData = content.data[0];
                            this.context.commit('setCurrentItemSelected', firstData);
                            this.context.commit('setListItemSelected', firstData);
                            this.context.commit('setListGrItem', list);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['uploadFilesGrHeader']({ file, apiUrl }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${process.env.VUE_APP_BASE_URL_DIGITAL}` + apiUrl;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('request', file);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(url, dataForm)
                    .then((response) => {
                    const check = response.data.result;
                    if (check.isError) {
                        this.context.commit('setErrorHandlerMigo', check);
                        resolve();
                    }
                    else {
                        const data = check.content;
                        const fileName = `${data[0].originalFileName}.${data[0].fileType}`;
                        const getFile = this.grHeaderForm.uploadGrPo.findIndex((s) => {
                            return s.originalFileName == fileName;
                        });
                        if (getFile >= 0) {
                            this.grHeaderForm.uploadGrPo[getFile] = Object.assign(Object.assign({}, data[0]), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['deleteFileGrHeader'](fileUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/upload?ver=v1&fileUrl=` +
                fileUrl;
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    const index = this.grHeaderForm.uploadGrPo
                        .map((x) => {
                        return x.formattedFileName;
                    })
                        .indexOf(fileUrl);
                    this.grHeaderForm.uploadGrPo.splice(index, 1);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['resetGR']() {
        // Variable GR direset disini ya, aku panggil mutation ini di onunmountednya GR
        this.listGrOther.data = [];
        this.tabConditionGr = 'header';
        this.isGrSearched = false;
        this.grHeaderForm = {
            typeReceipt: 'Goods Receipt',
            typeOrder: null,
            noPurchaseOrder: null,
            poItem: null,
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            grUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadGrPo: [],
            movementType: null,
            specialStock: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false,
            orderNumber: null,
            reservationNumber: null,
            equipment: null,
            orderCreator: ''
        };
        this.nextPrevItems = {
            data: []
        };
        this.headerError.documentDate = false;
        this.headerError.deliveryNote = false;
        this.headerError.postingDate = false;
        this.headerError.docHeaderText = false;
        this.grItemSelected.current = {};
        this.grItemSelected.list = [];
        this.grItemSelected.selectedItem = [];
        this.errorLists.postClicked = false;
        this.errorLists.checkClicked = false;
        this.errorLists.requiredAll = false;
        this.errorLists.snNotSame = false;
        this.errorLists.listItem = [];
        this.errorLists.listHeader = [];
        this.headerId = 0;
        this.importFileGrOther.files = null;
        this.importFileGrOther.store = [];
        this.importFileGrOther.isError = false;
        this.importFileGrOther.isImported = false;
        this.importFileGrOther.isAllowImport = true;
    }
    ['submitPost']({ conditions, data, typeOrder, isCancel }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = !isCancel
                ? `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/` +
                    typeOrder +
                    '/' +
                    conditions +
                    '?ver=v1'
                : `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/cancel?ver=v1`;
            if (isCancel) {
                data = {
                    header: data.header,
                    detail: data.detail
                };
            }
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, data)
                    .then((response) => {
                    const res = response.data.result;
                    this.importFileGrOther.isError = false;
                    if (res.isError && res.content === null) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else if (res.isError && res.content != null) {
                        this.context.commit('setHeaderId', res.content.headerId);
                        const errorItem = [];
                        const errorHeader = [];
                        if (res.content.isErrorSap) {
                            let fixValue = '';
                            if (typeOrder == 'po')
                                fixValue = 'PurchaseOrder';
                            else
                                fixValue = 'Other';
                            const obj = {
                                text: 'The display will switch to the "change" mode and please correct the data errors',
                                flag: conditions,
                                isErrorSap: true,
                                typeOrder: fixValue,
                                headerId: res.content.headerId
                            };
                            this.context.commit('setPreventDiscardMigo', true);
                            this.context.commit('setInformationMigo', obj);
                            resolve();
                        }
                        else {
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItem', errorItem);
                            this.context.commit('setErrorListHeader', errorHeader);
                            this.grItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        const obj = {
                            text: res.message,
                            flag: conditions,
                            isErrorSap: false,
                            typeOrder: null,
                            headerId: null
                        };
                        if (res.content.isInProgressSAP)
                            this.context.commit('setInformationMigo', obj);
                        else
                            this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    get getShowEdit() {
        return this.showEdit;
    }
    get getHideEdit() {
        return this.hideEdit;
    }
    ['setShowEdit'](data) {
        this.showEdit = data;
    }
    ['setHideEdit'](data) {
        this.hideEdit = data;
    }
    ['downloadFileGRMigo']({ trackingId, module }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/attachment?ver=v1&trackingId=` +
                trackingId +
                '&module=' +
                module;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    // const data = response.data.result.content
                    const data = response.data.result;
                    if (data.isError) {
                        this.context.commit('setErrorHandlerMigo', data);
                        resolve();
                    }
                    else {
                        const content = data.content;
                        window.location.href = content.link;
                    }
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callStorageBin']({ material, plant, sloc, index }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/storagebin?ver=v1&materialNumber=` +
                material +
                '&plant=' +
                plant +
                '&sloc=' +
                sloc;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        this.listGrOther.data[index].whereTab.storageBin =
                            content.storageBin;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callTypeOther']({ mvtype, specialstock, theIndex }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/mvtype/desc?MovementType=` +
                mvtype +
                '&SpecialStock=' +
                specialstock +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        this.listGrOther.data[theIndex].whereTab.type = content.mvtTypeDesc;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callGetSnNotBlank'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = isObject(data.materialNumber)
                ? data.materialNumber.lookupVal
                : data.materialNumber;
            const plant = isObject(data.plantName)
                ? data.plantName.lookupVal
                : data.plantName;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/isnotblank?ver=v1&materialNumber=${material}&plant=${plant}`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    this.context.commit('setIsSnNotBlank', res.data.result.content.isNotBlank);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['callGetStorageBin'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = this.grHeaderForm.typeOrder === 'PurchaseOrder'
                ? data.material
                : data.material.lookupVal;
            const plant = isObject(data.plant) ? data.plant.lookupVal : data.plant;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/storagebin?ver=v1&materialNumber=${material}&plant=${plant}&sloc=${data.sloc}`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    this.context.commit('setStorageBin', res.data.result.content.storageBin);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callDetailHeaderGr'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/detail/${headerId}?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        this.context.commit('setDetailGrHeader', Object.assign(Object.assign({}, res.content), { type: data.type }));
                        this.context.commit('setViewHeader', res.content);
                        const headerData = res.content.header;
                        const errorItem = [];
                        if (!headerData.isSAPSuccess) {
                            const getList = headerData.sapMessage.split(',');
                            getList.forEach((item) => {
                                const getLineName = item.split(':');
                                if (getLineName.length === 1) {
                                    errorItem.push({
                                        field: {
                                            name: '',
                                            tabCode: ''
                                        },
                                        errors: []
                                    });
                                    errorItem[0].errors.push(getLineName[0]);
                                    return;
                                }
                                const getNumberLine = getLineName[0].split(' ');
                                const checkError = errorItem.findIndex((itemSub) => {
                                    const getLine = itemSub.field.name.split('-');
                                    return getLine[1] === getNumberLine[1];
                                });
                                if (checkError !== -1) {
                                    errorItem[checkError].errors.push(getLineName[1]);
                                }
                                else {
                                    const messageData = () => {
                                        let message = '';
                                        getLineName.forEach((e, index) => {
                                            if (index !== 0)
                                                message += e + ' ';
                                        });
                                        return message;
                                    };
                                    const messageOneLine = () => {
                                        if (Number(getNumberLine[1]) === 0)
                                            return getLineName[1];
                                        else
                                            return headerData.sapMessage;
                                    };
                                    errorItem.push({
                                        field: {
                                            name: `Item-${getNumberLine[1]}`,
                                            tabCode: ''
                                        },
                                        errors: [
                                            getList.length === 1 ? messageOneLine() : messageData()
                                        ]
                                    });
                                }
                            });
                            this.context.commit('setErrorListItem', errorItem);
                        }
                        resolve(res.content);
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callDetailItemGr'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const type = data.params.viewType;
            const payloadData = data.params;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/detail/${headerId}/item?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, payloadData)
                    .then((response) => {
                    this.context.commit('setClearSelectedItem');
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        if (type === 'change' || type === 'cancel') {
                            this.listGrOther.data = [];
                            this.grItemSelected.list = [];
                            this.context.commit('deleteErrorListGrOther');
                            this.context.commit('reseterrorListGrCreate');
                            const data = res.content.data;
                            data.forEach((e) => {
                                store.commit('addGrOtherFromImport', Object.assign(Object.assign({}, e), { type }));
                                const obj = {
                                    line: e.line,
                                    materialTab: {
                                        material: null,
                                        materialDesc: null,
                                        valType: null
                                    },
                                    quantityTab: {
                                        baseUom: null,
                                        qty: null
                                    },
                                    whereTab: {
                                        movementType: null,
                                        slocCode: null,
                                        specialStock: null,
                                        plantCode: null,
                                        plantName: null,
                                        textItem: null,
                                        stockTypeCode: null,
                                        storageBin: null,
                                        unloadingPoint: null,
                                        goodsRecipient: null
                                    },
                                    partnerTab: {
                                        vendorCode: null,
                                        vendorName: null
                                    },
                                    accountAssignmentTab: {
                                        costCenter: null,
                                        orderNumber: null
                                    }
                                };
                                store.commit('pushTempGrOther', obj);
                            });
                            this.listGrOther.totalPages = res.content.totalPages;
                            this.listGrOther.totalRecords = res.content.totalRecords;
                            this.context.commit('setListGrItem', Object.assign(Object.assign({}, this.listGrOther), { totalPages: res.content.totalPages, totalRecords: res.content.totalRecords }));
                            this.context.commit('setCurrentItemSelected', this.listGrOther.data[0]);
                            if (type == 'change' || type == 'cancel') {
                                this.listGrOther.data.forEach((e) => {
                                    e.isActive = e.isCanceled && type === 'cancel' ? false : true;
                                    this.errorListGrCreate.push({
                                        qty: false,
                                        slocCode: false,
                                        reasonForMovement: false
                                    });
                                });
                                // selectedRows disini
                            }
                        }
                        else {
                            if (type === 'display' && this.grHeaderForm.typeOrder === 'Other')
                                this.context.commit('setListGrItemOther', res.content);
                            this.context.commit('setListGrItem', res.content);
                            this.context.commit('setCurrentItemSelected', res.content.data[0]);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['migoImportTemplate']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/other/downloadtemplate?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getBlob(apiUrl)
                    .then((response) => {
                    const fileName = response.headers['content-disposition']
                        .split('; ')[1]
                        .split('=')[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.context.commit('setPreventDiscardMigo', false);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['MigoImportFile']() {
        return __awaiter(this, void 0, void 0, function* () {
            this.importFileGrOther.isOnAsync = true;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/other/importexcel?ver=v1`;
            const dataForm = new FormData();
            dataForm.append('request', this.importFileGrOther.files);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    this.importFileGrOther.isOnAsync = false;
                    this.context.commit('setIsOnImportGr', true);
                    const res = response.data.result;
                    if (res.isError) {
                        if (res.content.data.length == 0) {
                            const errorData = {
                                statusCode: undefined,
                                message: res.content.errorSets[0].errors[0]
                            };
                            this.importFileGrOther.isError = true;
                            this.context.commit('setErrorHandlerMigo', errorData);
                            resolve();
                        }
                        else if (res.content.data.length > 0) {
                            this.importFileGrOther.isError = true;
                            this.importFileGrOther.isImported = true;
                            this.importFileGrOther.isAllowImport = false;
                            this.listGrOther.data = [];
                            this.grItemSelected.list = [];
                            this.context.commit('deleteErrorListGrOther');
                            const data = res.content.data;
                            let countDown = 0;
                            data.forEach((e) => {
                                countDown++;
                                store.commit('addGrOtherFromImport', e);
                                if (countDown === data.length) {
                                    store.commit('afterCountDown', res.content.errorSets);
                                }
                            });
                            const errorItem = [];
                            const errorHeader = [];
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItem', errorItem);
                            this.context.commit('setErrorListHeader', errorHeader);
                            this.grItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        this.listGrOther.data = [];
                        this.grItemSelected.list = [];
                        this.context.commit('deleteErrorListGrOther');
                        this.importFileGrOther.isImported = true;
                        this.importFileGrOther.isAllowImport = false;
                        const data = res.content.data;
                        data.forEach((e) => {
                            store.commit('addGrOtherFromImport', e);
                        });
                        hideModal(document.getElementById('modal_import_gr_item'));
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['deleteTransactionList'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsreceipt/delete/${headerId}?ver=v1`;
            const params = {};
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        const obj = {
                            text: res.message
                        };
                        this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    get getPrintGr() {
        return this.printGrUrl;
    }
    ['setPrintGr'](data) {
        this.printGrUrl = data;
    }
    ['printGr'](headerIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const stringHeaderIds = String(headerIds);
            const getUrl = window.location.href.split('/');
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/` +
                getUrl[6] +
                '/print?ver=v1&headerIds=' +
                stringHeaderIds;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    const resp = res.data.result;
                    if (resp.isError) {
                        this.context.commit('setErrorHandlerMigo', resp);
                        this.context.commit('setIsGrPrinted', false);
                        resolve();
                    }
                    else {
                        this.context.commit('setPrintGr', resp);
                        this.context.commit('setIsGrPrinted', true);
                        resolve();
                    }
                })
                    .catch((error) => {
                    this.context.commit('setIsGrPrinted', false);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['updateerrorListGrCreate'](obj) {
        this.errorListGrCreate[obj.index][obj.property] = obj.value;
    }
    ['reseterrorListGrCreate'](obj) {
        this.errorListGrCreate = [];
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setPayloadGr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setPlantListGr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setIsOnImportGr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setNextPrevGrMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setImportConditionMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setListGrOtherChange', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setGrHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setImportFileGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'deleteImportFileGrOtherr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setDetailGrHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'deleteErrorListGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'afterCountDown', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setTempGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'resetTempGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'pushTempGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'updateErrorListGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorListGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setPreventDiscardMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setTypeOrder', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setTempItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setTabConditionsGr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setGrLookup', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setGrOtherLookup', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setGrPoUpload', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setIsGrSearched', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setIsGrPrinted', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setSuccessClose', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setCurrentItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setListItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setEditItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setEditItemSelectedClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setSelectedListItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setSelectedListItemByIndex', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setSelectedItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setDeleteSelectedItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setClearSelectedItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setSelectedAllItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setListGrItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setListGrItemOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorRequiredAll', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorSnNotSame', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorListItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorListItemPush', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorListItemUnshift', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setErrorListHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setPostClicked', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setTempIdVal', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setHeaderId', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setIsSnNotBlank', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setStorageBin', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setMaterialDetail', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setBaseUomSku', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setResetSn', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'addGrOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'addGrOtherFromImport', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setViewHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setImportPopup', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callSearchGrPo', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'uploadFilesGrHeader', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'deleteFileGrHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'resetGR', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'submitPost', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setShowEdit', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setHideEdit', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'downloadFileGRMigo', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callStorageBin', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callTypeOther', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callGetSnNotBlank', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callGetStorageBin', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callDetailHeaderGr', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'callDetailItemGr', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'migoImportTemplate', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'MigoImportFile', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'deleteTransactionList', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'setPrintGr', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionModule.prototype, 'printGr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'updateerrorListGrCreate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionModule.prototype, 'reseterrorListGrCreate', null);
transactionModule = __decorate([
    Module
], transactionModule);
export default transactionModule;
